import { Link } from 'react-router-dom';
import './LegalFooter.css';

export default function LegalFooter() {
  return (
    <footer className="legal-footer">
      <span>© 2026 ТОО «OLSO PRO»</span>
      <span className="lf-sep">·</span>
      <Link to="/legal?tab=refund">Возврат</Link>
      <span className="lf-sep">·</span>
      <Link to="/legal?tab=terms">Правила</Link>
      <span className="lf-sep">·</span>
      <Link to="/legal?tab=privacy">Конфиденциальность</Link>
    </footer>
  );
}
